module.exports = __webpack_public_path__ + "static/media/notices icon (active).3410823c.svg";